import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../lib/utils';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const response = await axios.post(`${API_URL}/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage(response.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Verification failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-purple-25 px-6 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="h-16 w-16 mx-auto mb-4 text-purple-600 animate-spin" />
            <h2 className="text-2xl font-heading font-light mb-2">Verifying Email</h2>
            <p className="text-stone-600">Please wait while we verify your email address...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="h-16 w-16 mx-auto mb-4 text-green-600" />
            <h2 className="text-2xl font-heading font-light mb-2 text-green-800">Email Verified!</h2>
            <p className="text-stone-600 mb-6">{message}</p>
            <Button
              onClick={() => navigate('/shop')}
              className="rounded-full bg-purple-600 hover:bg-purple-700"
            >
              Start Shopping
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="h-16 w-16 mx-auto mb-4 text-red-600" />
            <h2 className="text-2xl font-heading font-light mb-2 text-red-800">Verification Failed</h2>
            <p className="text-stone-600 mb-6">{message}</p>
            <Button
              onClick={() => navigate('/login')}
              className="rounded-full bg-purple-600 hover:bg-purple-700"
            >
              Back to Login
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
